import * as Factory from 'factory.ts'
import faker from 'faker'

import { FinancialAccountStatuses } from '@webapp/platform/banking/entities/enums/FinancialAccountStatusEnum'
import { FinancialAccountTypes } from '@webapp/platform/banking/entities/enums/FinancialAccountTypeEnum'
import { type FinancialAccountApiModel } from '../FinancialAccountApiModel'

export const FinancialAccountApiModelStub =
  Factory.Sync.makeFactory<FinancialAccountApiModel>({
    id: Factory.each(() => faker.random.number()),
    status: FinancialAccountStatuses.ACTIVE,
    type: FinancialAccountTypes.AIRWALLEX_USD,
  })
